import type { Locale } from "../Locale.js";

export function getCoffeeStoreAnchor(locale: Locale): string {
	return { cs: "#fathers-store", en: "#fathers-store" }[locale];
}
